import { Users } from 'react-feather';

export const DROPDOWNITEMS = [
    {
        menutitle: 'Applications',
        Items: [
            {
                title: 'Users', icon: Users, path: `${process.env.PUBLIC_URL}/menu/user`, type: 'sub', bookmark: true, active: false, children: [
                    { path: `${process.env.PUBLIC_URL}/menu/user`, type: 'link', title: 'Users' },
                ]
            },
        ]
    },
];